import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import auth from "./modules/auth";
import shop from "./modules/shop";
import onboard from "./modules/onboard";
import product from "./modules/product";
import notification from "./modules/notification";
import menu from "./modules/menu";
import list from "./modules/list";
import loading from "./modules/loading";

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== "production";

export default new Vuex.Store({
  modules: {
    auth,
    shop,
    onboard,
    product,
    notification,
    menu,
    list,
    loading,
  },
  plugins: [createPersistedState()],
  state: {
    lastShop: null,
    feature1Request: false,
  },
  getters: {
    getLastShop: (state) => {
      return state.lastShop;
    },
    getFeature1Request: (state) => {
      return state.feature1Request;
    },
  },
  mutations: {
    saveLastShop(state, shopId) {
      state.lastShop = shopId;
    },
    updateFeature1Request(state, b) {
      state.feature1Request = b;
    },
    logout(state) {
      state.auth.user = null;
    },
  },
  strict: debug,
});
